import { useMutation } from '@tanstack/react-query';

import { useAvApi } from '@app-velocity/av-api-v2';

export const usePublishScenarioMutation = (workspaceId?: string, signal?: AbortSignal) => {
  const { prototypes } = useAvApi();

  return useMutation({
    mutationKey: ['publish-scenario-mutation'],
    mutationFn: async (prototypeId?: string) => {
      if (!workspaceId || !prototypeId) return;

      const res =
        await prototypes.putV2ProjectsPrototypesByProjectIdAndPrototypeId(
          {
            status: 'PUBLISHED',
          },
          {
            projectId: workspaceId,
            prototypeId,
          },
          {
            signal
          }
        );

      return res.data;
    },
  });
};
